// @moods/ui copy for NotificationRow / CountIconButton. tr and en must have identical keys.
// Turkish part; notifications.en.ts must have the same keys.
const dict: Record<string, string> = {
  'cards.notif.unread': 'Okunmamış',
};

export default dict;
